// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LoginIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LoginIcon" ref={forwardedRef} {...props}>
      <path d="M14.5 16.5v-13H8V2h7a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H8v-1.5z" />
      <path d="m12 10.001-4.242 4.243-1.06-1.061L9.13 10.75H3.5v-1.5h5.628l-2.43-2.431 1.06-1.06z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LoginIcon = /* @__PURE__ */ Object.assign(LoginIconComponent, {
  displayName: 'LoginIcon',
});
